import {ServiceConfigProviderV1} from "@volkswagen-onehub/service-config-provider";
import {LocaleServiceV1} from "@volkswagen-onehub/locale-service";
import {IConsentConfiguration} from "./ConsentService";

export class ConsentConfigurationBuilder {
    public constructor(private readonly serviceConfigProvider: ServiceConfigProviderV1,
                       private readonly localeService: LocaleServiceV1) {
    }

    public getConfiguration(): IConsentConfiguration {
        const consentCustomConfig = this.serviceConfigProvider.configs.consent?.customConfig as any;
        if (!consentCustomConfig
            || !consentCustomConfig.appName
            || !consentCustomConfig.termsAndConditionsTextId
            || !consentCustomConfig.privacyStatementTextId) {
            throw new Error('Consent configuration is missing or incomplete');
        }
        return {
            consentEndpoint: this.serviceConfigProvider.configs.consent!.urlOrigin,
            appName: consentCustomConfig.appName,
            termsAndConditionsTextId: consentCustomConfig.termsAndConditionsTextId,
            privacyStatementTextId: consentCustomConfig.privacyStatementTextId,
            countryCode: this.localeService.countryCode,
            language: this.localeService.language
        };
    }
}